// extracted by mini-css-extract-plugin
export default {"paginationControls":"styles_paginationControls__uHH5R","buttonsContainer":"styles_buttonsContainer__P09gP","tfooter":"styles_tfooter__jja78"};